export default "__VITE_PUBLIC_ASSET__6a6c826f__"